<template>
  <div v-show="dialog">
    <div class="modal">
      <form @submit.prevent="submit">
        <button @click="dismiss" type="button">✕</button>
        <h1>Nevíte si rady s výběrem?</h1>
        <p>Vyplňte telefonní číslo a my Vám poradíme.</p>
        <input
            type="tel"
            name="phone"
            placeholder="Telefon"
            v-model="contactPhone"
            required
        >
        <div class="buttons big">
          <button
              :disabled="isContactDisabled"
              class="button blue"
              type="submit"
          >Odeslat</button>
        </div>
        <small>Odesláním souhlasíte se zpracováním osobních údajů a <a target="_blank" href="/media/podminky.pdf">podmínkami</a>.</small>
      </form>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import QS from 'qs'

export default {
  name: 'VDialogContact',
  data () {
    return {
      dialog: false,
      contactPhone: null,
      sending: false
    }
  },
  computed: {
    isContactDisabled () {
      return !this.contactPhone || this.sending
    }
  },
  mounted () {
    const result = window.localStorage.getItem('dobryinternet.cz-dialog')
    if (result === null) {
      const self = this
      window.setTimeout(function () {
        console.log('timeout')
        self.dialog = true
      }, 15000)
    }
  },
  methods: {
    dismiss () {
      window.localStorage.setItem(
        'dobryinternet.cz-dialog',
        Math.floor(Date.now() / 1000).toString()
      )
      this.dialog = false
    },
    submit () {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.sending) return
      this.sending = true
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute('6LeA-LAqAAAAAIPA798aFTV1-_e8qMQ-35Zjz-0F', { action: 'submit' }).then((token) => {
          Axios.post('/nezavazna-poptavka', QS.stringify({
            contactPhone: this.contactPhone,
            recaptchaToken: token
          }))
            .then(() => {
              this.contactPhone = null
              this.dismiss()
              window.location.href = '/dekujeme-za-poptavku'
            })
            .catch((err) => {
              // Zkusíme přečíst chybovou hlášku z odpovědi serveru
              const message = err && err.response && err.response.data && err.response.data.message
              alert(message || 'Nastala chyba při odeslání kontaktního formuláře')
              this.sending = false
            })
        })
      })
    }
  }
}
</script>
